const browser = "undefined" !== typeof window;

export default browser;
